// =============================================================
// 📈 SessionsPerDayChart.jsx — Atendimentos por dia
// =============================================================

import React from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

export default function SessionsPerDayChart({ data }) {
  if (!data || data.length === 0) {
    return <div className="ia-chart-empty">Sem dados suficientes ainda.</div>;
  }

  return (
    <div className="ia-chart-wrapper">
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3c5d8" />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: "#b22857" }} />
          <YAxis tick={{ fontSize: 11, fill: "#b22857" }} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#d81b60"
            strokeWidth={2.4}
            dot={{ r: 3, fill: "#d81b60" }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
